import { fileExtensionFromMimeType } from '../../../shared/domain/files/fileExtensions.no-deps'
import { type FileId, generateFileId } from '../../../shared/domain/files/types.no-deps'
import { createFileName } from '../../../shared/domain/flows/types.no-deps'
import { doNothing } from '../../../shared/lib/functional/function.no-deps'
import type { ApiClient } from '../util/ApiClient'
import { fileBuffer } from './buffer'
import { chunkReaderForBuffer } from './chunk'
import { createFileUploadData } from './FileUploadData'
import { sendFileMeta } from './sendFileMeta'
import { sendToS3 } from './sendToS3'

type Options = {
    fileName?: string
    fileId?: FileId
    abortSignal?: AbortSignal
}

export async function uploadBlobWithoutQueue(apiClient: ApiClient, blob: Blob, options: Options = {}) {
    const fileId = options.fileId || generateFileId()
    const filename = options.fileName ?? createFileName(fileId, fileExtensionFromMimeType(blob.type))
    const fileUploadData = createFileUploadData(fileId, filename, blob.size, blob.type)
    const reader = chunkReaderForBuffer(fileBuffer(blob))
    await sendFileMeta(apiClient, fileUploadData)
    await sendToS3({ fileUploadData, reader, apiClient, onProgress: doNothing, abortSignal: options.abortSignal })
    return fileUploadData
}
